
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BasicSetupScreen from '@components/vehicle-setup/BasicSetupScreen.vue';
import { Vehicle } from '@clients/myTrips';

@Component({
  name: 'SetupStep1',
  components: {
    BasicSetupScreen,
  }
})
export default class SetupStep1 extends Vue {
  @Prop({ required: true })
  private vehicle: Vehicle;

  get publicFolder() {
    return process.env.BASE_URL;
  }

  get licensePlate() {
    return this.vehicle.licensePlate;
  }

  get vehicleModel() {
    return `${this.vehicle.brand} ${this.vehicle.model}`;
  }

  get setupError() {
    return this.vehicle.setupDone !== false || !this.vehicle.deviceId
  }
}
